// @flow

import axios from 'axios';
import config from '../../config';

export const fileManagerAPI = axios.create({
  baseURL: config.file_manager_api_url,
  timeout: 30000
});
